import React from 'react';
import "./latestNewsSkeleton.css";

function LatestNewsSkeleton({ cardNums = 4}) {
  return (
    <div className="latest_news_wrapper">
      <div className="latest_news_block">
        <h5 
          className="latest_news_head baseSkeleton skeleton-text" 
          style={{ width: '200px' }}
        ></h5>
        <div className="top_slider_btn">
          <button 
            className="carousel__button carousel__button--next skeleton" 
            style={{ width: '30px', height: '30px' }}
          ></button>
          <button 
            className="carousel__button carousel__button--prev skeleton" 
            style={{ width: '30px', height: '30px' }}
          ></button>
        </div>
      </div>
      <div className="carousel">
        <div className="slider-wrapper">
          <div className="slider-content">
            {[...Array(cardNums)].map((_, index) => (
              <div className="slider-item" key={index}>
                <div className="latest_news_tile">
                  <div className="image_block_news">
                    <div className="baseSkeleton skeleton-image"></div>
                  </div>
                  <div className="latest_news_info">
                    <h5 
                      className="latest_news_head baseSkeleton skeleton-text" 
                      style={{ width: '80%' }}
                    ></h5>
                    <p 
                      className="latest_news_time baseSkeleton skeleton-text" 
                      style={{ width: '60%' }}
                    ></p>
                    <ul className="latest_news_tags">
                      {[...Array(2)].map((_, tagIndex) => (
                        <li key={tagIndex} className="latest_news_taglist">
                          <span className="tags_link baseSkeleton skeleton-tag"></span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LatestNewsSkeleton;
